// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4886":"6a5a405a72fab9c4","6735":"919fa80c267de93c"}[chunkId] + ".js";
};